const TIME_ZONE_ALMATY = 'Asia/Almaty';

export {TIME_ZONE_ALMATY};
